import { Component } from '@angular/core';
import { FormControl, FormArray, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Response } from 'src/app/Models/Response';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-promocode',
  templateUrl: './promocode.component.html',
  styleUrls: ['./promocode.component.css']
})
export class PromocodeComponent {
  couponTypes: string[] = ['Percentage Off', 'Amount Off', 'Flat Percentage Off'];
  displayCouponTypes: string[] = [];

  CouponCode = new FormControl('', [
    Validators.required
  ]);
  Description = new FormControl('', [
    Validators.required
  ]);
  CouponType = new FormControl('', [
    Validators.required
  ]);
  Amount = new FormControl('', [
    Validators.required
  ]);
  Percentage = new FormControl('', [
    Validators.required
  ]);
  ValidityDate = new FormControl('', [
    Validators.required
  ]);
  todayDate: Date = new Date();
  ValidDate: string='';
 
  constructor(public service : SharkifyAiSerivceService, public app: AppComponent, private toastr: ToastrService,public datepipe : DatePipe) {

  }

  ngOnInit(): void {

  }
  onCouponTypeChange(event: any): void {
    const selectedCouponType = event.value;
    this.updateDisplayCouponTypes(selectedCouponType);
  }

  updateDisplayCouponTypes(selectedCouponType: string): void {
    this.displayCouponTypes = [];
    if (selectedCouponType === 'Flat Percentage Off') {
      this.displayCouponTypes.push('Percentage Off', 'Amount Off');
    } else {
      this.displayCouponTypes.push(selectedCouponType);
    }
  }

  toSubmit() {
    var Error = 0;
    if (this.CouponCode.valid && this.CouponType.valid && this.ValidityDate.valid && this.Description.valid ) {
      
      if(this.CouponType.value == "Flat Percentage Off"){
        if(this.Amount.valid && this.Percentage.valid){
          Error = 0;
        }else{
          Error = Error+1;
          this.showError('Please Enter valid details');
        }
      }else if(this.CouponType.value == 'Percentage Off'){
        if(this.Percentage.valid){
          Error = 0;
        }else{
          Error = Error+1;
          this.showError('Percentage is not Valid');
        }
      }else if(this.CouponType.value == 'Amount Off'){
        if(this.Amount.valid){
          Error = 0;
        }else{
          Error = Error+1;
          this.showError('Amount is not Valid');
        }
      }
      
      if(Error == 0){
        this.ValidDate = this.ValidityDate.value == null || this.ValidityDate.value == undefined ? "" : this.datepipe.transform(this.ValidityDate.value,"MM/dd/yyyy")+ "";
        this.service.AddPromoCode(this.CouponCode.value + "", this.CouponType.value + "", this.Amount.value + "", this.Percentage.value + "",this.Description.value + "", this.ValidDate + "").subscribe(data => {
      
          if (data.Code === 200){
   
            this.showSuccess('Submited Successfull')
          }
          else {
            this.showError('Submit Failed. ')
          }
        },(error: any) => {
          this.showError('Server error occurred. Please try again later.');
        });
      }
    }
    else {
      this.showError('Please fill in valid credentials.');
    }
  }
  private showSuccess(message: string): void {
    this.toastr.success(message, 'Success', {
      toastClass: 'ngx-toastr toast-success'
    });
  }
  private showError(message: string): void {
    this.toastr.error(message, 'Error', {
      toastClass: 'ngx-toastr toast-error'
    });

  }

 
}